export default __webpack_public_path__ + "static/media/placeholder_dummy2016-sportbekleidung01-mobile-de.c2e337f4.png";